// extracted by mini-css-extract-plugin
export default {"container":"Oj-z","links":"Pj-z"};